import * as Action from './action';

const defineInitialState = () => ({
  isAuthenticated: false,
  session: null,
  token: '',
});

export function reducer(state = defineInitialState(), action) {
  switch (action.type) {
    case Action.$reset.ACTION:
      return defineInitialState();
    case Action.$signin.REQUEST:
      return {
        ...state,
        session: null,
        token: '',
      };
    case Action.$signin.SUCCESS:
      return {
        isAuthenticated: true,
        session: {
          user: action.response.user,
          usergroup: action.response.usergroup,
          privileges: action.response.privileges,
          client: action.response.client || action.response.user,
          hub: action.response.hub,
        },
        token: action.response.token,
      };
    case Action.$fetchProfile.SUCCESS:
      return {
        ...state,
        session: {
          user: action.response.user,
          usergroup: action.response.usergroup,
          privileges: action.response.privileges,
          client: action.response.client || action.response.user,
          hub: action.response.hub,
        },
      };
    case Action.$logout.ACTION:
      return {
        isAuthenticated: false,
        session: null,
        token: '',
      };
    default:
      return state;
  }
}

export function persister({ isAuthenticated, session, token }) {
  return {
    isAuthenticated,
    session,
    token,
  };
}
